import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form, Grid, Icon, Table } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { cardSelector } from '../../../../ducks/gridCard';
import Number from '../../../../components/BaseComponents/Number';
import FormField from '../../../../components/BaseComponents';
import { SELECT_TYPE } from '../../../../constants/columnTypes';


const EditField = ({ value, name, onChange, error = [] }) => {
    return (
        <>
            {name === 'additionalCostType' ? (
                <Grid.Column >
                    <FormField
                        name={name}
                        value={value}
                        error={error && error.includes('additionalCostType')}
                        source={'additionalCostType'}
                        onChange={onChange}
                        key={'additionalCostType'}
                        type={SELECT_TYPE}
                        noLabel={true}
                        isRequired={true}
                    />
                </Grid.Column>
            ) : name === 'costConditionId' ? (
                <Grid.Column >
                    <FormField
                        name={name}
                        value={value}
                        error={error && error.includes('costConditionId')}
                        source={'costConditions'}
                        onChange={onChange}
                        key={'costConditionId'}
                        type={SELECT_TYPE}
                        noLabel={true}
                        isRequired={true}
                    />
                </Grid.Column>
            ) : (
                <Number
                    value={value}
                    isInteger={name !== 'rate'}
                    name={name}
                    onChange={onChange}
                    noLabel={true}
                    error={error && error.includes(name)}
                    isRequired={true}
                />
            )}
        </>
    );
};

const TariffAdditionalCosts = ({ form, onChange, gridName, formColumns, load, settings: baseSettings }) => {
    const { t } = useTranslation();
    let [tariffAdditionalCosts, setTariffAdditionalCosts] = useState([...(form.tariffAdditionalCosts || [])]);
    let [indexEdit, setIndexEdit] = useState(null);
    let [error, setError] = useState([]);

    const card = useSelector(state => cardSelector(state));

    let columns = [];
    if (formColumns && formColumns.some((e) => e.name === 'costConditionId' && !e.isHidden)) {
        columns.push({ name: 'costConditionId' });
    } else {
        columns.push({ name: 'additionalCostType' });
    }
    columns.push({ name: 'rate' });

    useEffect(
        () => {
            setTariffAdditionalCosts(form.tariffAdditionalCosts || []);
        },
        [form.tariffAdditionalCosts],
    );

    const editTariffAdditionalCosts = tariffAdditionalCosts => {

        onChange(null, {
            name: 'tariffAdditionalCosts',
            value: tariffAdditionalCosts,
        })
    };

    const handleDeleteItem = index => {
        const newTariffAdditionalCosts = tariffAdditionalCosts.filter((item, i) => i !== index);
        editTariffAdditionalCosts(newTariffAdditionalCosts);
    };

    const handleEditItem = index => {
        setIndexEdit(index);
    };

    const handleSaveItem = () => {
        editTariffAdditionalCosts(tariffAdditionalCosts);
        setIndexEdit(null);
        setError([]);
    };

    const handleChangeField = (e, { name, value }) => {
        const newColumns = [...tariffAdditionalCosts];

        newColumns[indexEdit] = {
            ...tariffAdditionalCosts[indexEdit],
            [name]: value,
        };

        setTariffAdditionalCosts(newColumns);
    };

    const handleCancelItem = index => {
        setTariffAdditionalCosts([tariffAdditionalCosts]);
        setTariffAdditionalCosts([...form.tariffAdditionalCosts]);
        setIndexEdit(null);
        setError(false);
    };

    const handleAddTariffAdditionalCosts = () => {
        setTariffAdditionalCosts([...tariffAdditionalCosts, {}]);
        setIndexEdit(tariffAdditionalCosts.length);
    };

    return (
        <Form className="tabs-card">
            <Grid>
                <Grid.Row>
                    <Grid.Column className="add-right-elements">
                        <Button disabled={indexEdit !== null} onClick={handleAddTariffAdditionalCosts}>
                            {t('AddButton')}
                        </Button>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row className="padding-14">
                    <Table className="wider container-margin-top-bottom">
                        <Table.Header>
                            <Table.Row>
                                {columns.map(column => (
                                    <Table.HeaderCell key={column.name}>
                                        {t(column.name)}
                                    </Table.HeaderCell>
                                ))}
                                <Table.HeaderCell />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {tariffAdditionalCosts ? tariffAdditionalCosts.map((row, index) => (
                                <Table.Row key={row.id}>
                                    {columns.map(column => (
                                        <>
                                            {index === indexEdit ?
                                                (<Table.Cell
                                                    key={`cell_${row.id}_${column.name}_${index}`}
                                                    className={`table-edit-field-tariffs`}
                                                >
                                                    <EditField
                                                        value={row[column.name]}
                                                        name={column.name}
                                                        error={error}
                                                        onChange={handleChangeField}
                                                    />
                                                </Table.Cell>
                                                )
                                                :
                                                (
                                                    <Table.Cell
                                                        key={`cell_${row.id}_${column.name}_${index}`}
                                                    >
                                                        {(column.name !== 'rate' && row[column.name]) ? t(row[column.name].name) : t(row[column.name])}
                                                    </Table.Cell>
                                                )}
                                        </>
                                    ))}
                                    <Table.Cell
                                        textAlign="right"
                                        className="table-action-buttons"
                                    >
                                        {index === indexEdit ? (
                                            <>
                                                <Button
                                                    icon
                                                    onClick={() => handleCancelItem(index)}
                                                >
                                                    <Icon name="undo alternate" />
                                                </Button>
                                                <Button
                                                    icon
                                                    onClick={() => handleSaveItem(index)}
                                                >
                                                    <Icon name="check" />
                                                </Button>
                                            </>
                                        ) : (
                                            <>
                                                <Button
                                                    disabled={indexEdit !== null}
                                                    icon
                                                    onClick={() => handleEditItem(index)}
                                                >
                                                    <Icon name="pencil alternate" />
                                                </Button>
                                                <Button
                                                    disabled={indexEdit !== null}
                                                    icon
                                                    onClick={() => handleDeleteItem(index)}
                                                >
                                                    <Icon name="trash alternate" />
                                                </Button>
                                            </>
                                        )}
                                    </Table.Cell>
                                </Table.Row>
                            ))
                                : null}
                        </Table.Body>
                    </Table>
                </Grid.Row>
            </Grid>
        </Form>
    );
};

export default TariffAdditionalCosts;
